import Button from '@shared/components/Button/Button';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import CustomReminder from './CustomReminder/CustomReminder';
import DefaultReminder from './DefaultReminder';
import { getCustomRemindersCount, getUnitTranslation, UnitsEnum } from './utils';
import useCreateNewRoomDataContext from '../CreateNewRoomDataProvider/useCreateNewRoomDataContext';

const RemindersList = () => {
  const { t } = useTranslation();
  const {
    roomForm: { watch, control },
  } = useCreateNewRoomDataContext();
  const { fields, append } = useFieldArray({ control, name: 'reminders' });

  const appendCustomReminder = () => append({ unit: UnitsEnum.MINUTES, enabled: false, isCustom: true });

  const remindersWatch = watch('reminders');
  const isEnabledRemindersLimitReached = remindersWatch.filter(({ enabled }) => enabled).length >= 3;
  const isMaxCustomRemindersLimitReached = getCustomRemindersCount(remindersWatch) >= 3;
  const isAddButtonDisabled = isMaxCustomRemindersLimitReached || isEnabledRemindersLimitReached;

  return (
    <div className="flex flex-col items-start gap-4 pb-4">
      {fields.map(({ id, amount, unit, isCustom }, index) =>
        isCustom ? (
          <CustomReminder key={id} index={index} />
        ) : (
          <DefaultReminder key={id} id={id} index={index}>
            {getUnitTranslation(unit, amount || 0, true)}
          </DefaultReminder>
        )
      )}
      <Button
        variant="text"
        size="sm"
        className="!font-medium"
        onClick={appendCustomReminder}
        disabled={isAddButtonDisabled}
      >
        {t('add_custom_reminder')}
      </Button>
    </div>
  );
};

export default RemindersList;
